<router-outlet></router-outlet>
<div *ngIf="updateAvailable" class="top-alert alert text-center alert-success animate__animated animate__backInRight" role="alert">
    Des mises à jour sont disponibles et seront intégrées dans votre application. <button class="btn btn-success" (click)="updateApp()">Ok</button>
</div>